function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This is a type-safe browser implementation of EventEmitter in node.js with
 * slight differences
 *
 * @see https://nodejs.dev/learn/the-nodejs-event-emitter
 */
export var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);
    this.eventCallbacks = {};
  }
  _createClass(EventEmitter, [{
    key: "on",
    value:
    /**
     * Subscribes to an event.  The provided callback will be called when the event is emitted
     *
     * @param eventName The name of the event to subscribe to
     * @param callback The callback that will be called
     * @returns A function that when called will unsubscribe
     */
    function on(eventName, callback) {
      var _this$eventCallbacks$,
        _this = this;
      if (!this.eventCallbacks[eventName]) {
        this.eventCallbacks[eventName] = [];
      }
      (_this$eventCallbacks$ = this.eventCallbacks[eventName]) === null || _this$eventCallbacks$ === void 0 ? void 0 : _this$eventCallbacks$.push(callback);

      // For convenience, returns a function that unsubscribes when called (even though node.js doesn't do this)
      return function () {
        var callbackArray = _this.eventCallbacks[eventName];
        if (callbackArray) {
          callbackArray.splice(callbackArray.indexOf(callback), 1);
        }
      };
    }

    /**
     * Emits the event, calling all registered callbacks
     * @param eventName The name of the event to emit
     * @param args The args to pass to the callback.  Some events don't require args
     */
  }, {
    key: "emit",
    value: function emit(eventName) {
      var _this$eventCallbacks$2;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      // @ts-expect-error This is type-safe but typescript isn't smart enough to realize it
      (_this$eventCallbacks$2 = this.eventCallbacks[eventName]) === null || _this$eventCallbacks$2 === void 0 ? void 0 : _this$eventCallbacks$2.forEach(function (callback) {
        return callback.apply(void 0, args);
      });
    }
  }]);
  return EventEmitter;
}();